import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DriverImportService } from 'src/app/services/driver-import.service';
import { CommonService } from 'src/app/services/common.service';

import { VrmDriverImportGridComponent } from './driver-import-grid/vrm-driver-import-grid.component';
import { ImportConfigurationDialogComponent } from './dialogs/import-configuration-dialog.component';
import { DriverImportGridItem, FileUploadConfig, GridMeta, ImportConfigurationItem } from './driver-import-interfaces';
import { tap } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
@Component({
  selector: 'vrm-driver-import',
  templateUrl: './driver-import.component.html',
  styleUrls: ['./driver-import.component.scss'],
})
export class DriverImportComponent implements OnInit, AfterViewInit {
  @ViewChild(VrmDriverImportGridComponent) driverImportGrid!: VrmDriverImportGridComponent;

  private subscriptions = {
    headerSearchToggled: null,
    headerSearchInputChanged: null,
  };
  fileUploadConfig: FileUploadConfig;
  fileType: string = 'all';
  jsonDataArray: DriverImportGridItem[] = [];
  columnKeys: string[];
  showUploader: boolean = true;
  companyName: string;
  hasConfigurations: boolean = false;
  configurations = [];
  percentProgress = { value: 0 };
  showProgressBar: boolean = false;
  selectedConfig: string = 'system-standard';
  fileName: string = 'abc.csv';

  gridMeta: GridMeta;
  data: DriverImportGridItem[] = [];
  file: File;
  constructor(
    public cService: CommonService,
    private driverImportService: DriverImportService,
    private dialog: MatDialog
  ) {}
  ngAfterViewInit(): void {
    this.cService.setPageHeader('Driver Import', true, false);
    this.subscriptions.headerSearchInputChanged = this.cService.headerSearchInputChanged$.subscribe({
      next: (searchText: string) => {
        this.driverImportGrid.setQuickFilter(searchText);
      },
    });
  }

  ngOnInit(): void {
    this.companyName = this.cService.userProfile?.company;

    this.driverImportService
      .getMeta(this.companyName)
      .pipe(
        tap((response) => {
          this.gridMeta = response.bodyResponse;
        })
      )
      .subscribe();

    this.updateDriverImportPage();
  }

  preprocessFile(data: DriverImportGridItem[], file: File): void {
    this.fileName = file.name;
    this.file = file;
    this.showUploader = false;
    this.jsonDataArray = data;
    this.columnKeys = Object.keys(this.jsonDataArray[0]);
  }

  openUploadDialog(): void {
    const importConfigDiagRef = this.dialog.open(ImportConfigurationDialogComponent, {
      width: '70%',
      data: {
        command: 'upload',
        importConfigurations: this.configurations,
        callBack: this.updateDriverImportPage.bind(this),
      },
    });
    importConfigDiagRef.afterClosed().subscribe(() => {
      this.updateDriverImportPage();
    });
  }

  openEditDialog(): void {
    const dialogRef = this.dialog.open(ImportConfigurationDialogComponent, {
      width: '70%',
      data: {
        command: 'editConfig',
        importConfigurations: this.configurations,
        callBack: this.updateDriverImportPage.bind(this),
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.updateDriverImportPage();
    });
  }

  getAllImportHistory() {
    this.showProgressBar = true;

    this.driverImportService.getJobHistory(this.companyName).subscribe({
      next: (event) => {
        if (event instanceof HttpResponse) {
          this.updateHistoryGrid(event.body?.bodyResponse?.items || []);
          this.showProgressBar = false;
        }
      },
      error: (error) => {
        console.error('Error fetching import history:', error);
        this.showProgressBar = false;
      },
    });
  }

  getConfigurarions() {
    this.showProgressBar = true;

    this.driverImportService.getAllConfigurations(this.companyName).subscribe({
      next: (event) => {
        if (event instanceof HttpResponse) {
          this.setConfigsOnUi(event.body.bodyResponse.items);
          this.showProgressBar = false;
        }
      },
      error: (error) => {
        console.error('Error fetching configurations:', error);
        this.showProgressBar = false;
      },
    });
  }

  updateDriverImportPage() {
    this.getConfigurarions();
    this.getAllImportHistory();
  }

  private setConfigsOnUi(items: ImportConfigurationItem[]) {
    this.configurations = items;
    this.hasConfigurations = this.configurations.length > 0;
  }
  private updateHistoryGrid(items: DriverImportGridItem[]) {
    if (!items) return;

    this.data = items.map((item: DriverImportGridItem) => {
      const isUpload = item.source === 'UPLOAD';
      return {
        jobId: item.jobId ?? '',
        importSource: item.source ?? '',
        updateType: item.config?.type ?? '',
        jobStatus: item.jobStatus ?? '',
        completedTime: item.completedAt ?? '',
        processedFile: item.fileEndpoint?.original ?? '',
        importedBy: isUpload ? item.createdBy ?? '' : item.source ?? '',
        statistics: item.statistics,
        fileEndpoint: item.fileEndpoint,
        createdAt: item.createdAt ?? '',
        approvedBy: item.approvedBy ?? '',
        approvedAt: item.approvedAt ?? '',
        rejectedAt: item.rejectedAt ?? '',
        rejectedBy: item.rejectedBy ?? '',
      };
    });

    this.data.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  }
}
